import clsx from "clsx";
import { Typography } from "../Typography/Typography";
import styles from "./Tag.module.scss";
import { PlusIcon, XIcon } from "@/frontend/shared/assets/icons";
import { ReactNode, useState } from "react";

type TTagProps = {
  children: string | string[];
  type?: "innovera" | "add" | "custom";
  icon?: ReactNode | null;
  onClose?: () => void;
  className?: string;
};

export function Tag({ children, type = "custom", onClose, className, icon = null }: TTagProps) {
  // const [isHidden, setIsHidden] = useState(false);

  function handleClose() {
    // setIsHidden(true);
    onClose?.();
  }

  if (type === "add") {
    return (
      <div className={styles.isEmptyContainer}>
        <PlusIcon className={styles.plusIcon} />
        <Typography variant="label-5" color="greyscale600">
          Tag
        </Typography>
      </div>
    );
  } else if (type === "innovera") {
    return (
      <div className={clsx(styles.container, styles.innoveraTag, className)}>
        {/* isHidden && styles.hidden, */}
        <Typography variant="label-5" color="innovera-orange900" className={styles.textContainer}>
          {children}
        </Typography>
        {!!onClose ? <XIcon onClick={handleClose} className={styles.closeIcon} /> : null}
      </div>
    );
  } else {
    return (
      <div className={clsx(styles.container, styles.customTag, className)}>
        {/* isHidden && styles.hidden, */}
        {icon}
        <Typography variant="label-5" color="greyscale900" className={styles.textContainer}>
          {children}
        </Typography>
        {!!onClose ? <XIcon onClick={handleClose} className={styles.closeIcon} /> : null}
      </div>
    );
  }
}
